import ReportRequests from '../../server/report';
import { addLoading, removeLoading } from './loading';

// eslint-disable-next-line import/prefer-default-export
export const getPurchaseReport = (initialDate, finalDate) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ReportRequests.getPurchaseReport(initialDate, finalDate);
  } finally {
    dispatch(removeLoading());
  }
};
